module.exports = __webpack_public_path__ + "static/media/construction_white_on_blue_24dp.b95a2ddd.svg";